<template>
  <div class="select-private horizontal" :class="{ 'focus': isFocus, 'disabled': disabled }">
    <p class="label" v-if="label" @click="onSelect()">{{ label }}</p>
    <input 
      class="input-item"
      :class="{'disabled': disabled, 'no-label': !label}"
      :placeholder="placeholder"
      :value="valueText"
      @focus="isFocus = true"
      @blur="isFocus = false"
      readonly
      @click="onSelect()"
    />
    <van-icon class="arrow" :class="{'disabled': disabled}" name="arrow-down" @click="onSelect()"/>
    <van-popup v-model:show="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Icon, Popup, Picker } from 'vant';

export default {
  props: {
    label: String,
    placeholder: String,
    modelValue: String,
    columns: Array,
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isFocus: false,
      showPicker: false,
    };
  },
  computed: {
    valueText() {
      const index = this.columns.findIndex(v => v.id === this.modelValue);
      return index >= 0 ? this.columns[index].text : '';
    }
  },
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon
  },
  methods: {
    onSelect() {
      this.showPicker = true;
    },
    onConfirm(value) {
      this.$emit('update:modelValue', value.id)
      this.showPicker = false;
    },
  },
  created() {},
  async mounted() {
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.select-private {
  .input-wrap();
  position: relative;
  .input-item {
    padding-right: 26px;
    vertical-align: middle;
    &.no-label {
      text-indent: 0;
    }
  }
  .arrow {
    font-size: @font-size-2;
    position: absolute;
    top: 13px;
    right: 12px;
    color: var(--theme-main-color);
    &.disabled {
      color: var(--van-gray-5);
    }
  }
}
</style>
